import React, { useState, useEffect, useRef } from 'react'

import { Auth } from 'aws-amplify'
import { gql, useQuery } from '@apollo/client'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import { EditableGeoJsonLayer } from '@nebula.gl/layers'
import { PathStyleExtension, DataFilterExtension } from '@deck.gl/extensions'
import { ViewMode, DrawPolygonMode, DrawPointMode, DrawLineStringMode, ModifyMode } from '@nebula.gl/edit-modes'

import { Layout, Spin } from 'antd'
import { LoadingOutlined, UserOutlined } from '@ant-design/icons'

import {
  updateAuthData,
  LOGED_IN,
  LOGED_OUT,
  CHANGE_PASSWORD_CHALLENGE,
  EMAIL_VERIFICATION_CHALLENGE,
} from 'store/auth/auth'
import { setCountrySelected } from 'store/global/countrySelected'
import { setUserCompanyId, setUserCompanyName } from 'store/global/userCompany'
import { setViewStateStore } from 'store/global/map/viewState'

import Sidebar from 'components/Sidebar/Sidebar'
//import tychoLogo from 'assets/tycho-logo.png'
import tychoLogo from 'assets/logo-quadrant-blanco.png'
import './App.less'
import './Documents.css'
import './App.css'
import Map from 'components/Map/Map'
import GeoMap from 'components/Geocreator/GeoMap'
import Documents from 'components/Documents/Documents'
import UserInfo from 'components/UserInfo/UserInfo'
import UsersManager from 'components/UsersManager/UsersManager'
import UnifilarEditor from 'components/UnifilarEditor/UnifilarEditor'

import RpcApiClient from 'datasources/RpcApiClient'

function App(props) {
  // const TYCHO_RPC_API = getEnv('REACT_APP_TYCHO_RPC_API')
  // let socket;

  const dispatch = useDispatch()
  const authData = useSelector((state) => state.auth.authData)
  const countrySelected = useSelector((state) => state.countrySelected.data)
  const filesMenuInfo = useSelector((state) => state.filesMenuInfo)

  const mapLayersRef = useRef()

  const [loadingUserInfo, setLoadingUserInfo] = useState(false)
  const [userInfo, setUserInfo] = useState({})
  const [loadingMaps, setLoadingMaps] = useState(false)
  const [maps, setMaps] = useState([])
  const [loadingCompanies, setLoadingCompanies] = useState(false)
  // const [companies, setCompanies] = useState('')
  const [viewState, setViewState] = useState()
  const [features, setFeatures] = useState({
    type: 'FeatureCollection',
    features: [],
  })
  const [mode, setMode] = useState(() => ViewMode)
  const [selectedFeatureIndexes, setSelectedFeatureIndexes] = useState([0])

  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => (prevSeconds === 240 ? 0 : prevSeconds + 1))
      // setSeconds((prevSeconds) => prevSeconds === 60 ? 0 : prevSeconds + 1);
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const geoLayer = new EditableGeoJsonLayer({
    id: 'draw-copy',
    data: features,
    mode: mode,
    selectedFeatureIndexes,
    getRadius: 5,
    pointRadiusMinPixels: 5,
    pointRadiusScale: 1,
    _subLayerProps: {
      geojson: {
        getFillColor: (d) => (d.properties.fillColor ? d.properties.fillColor : [77, 77, 77, 125]),
        getLineColor: (d) => (d.properties.lineColor ? d.properties.lineColor : [37, 37, 37]),
        getLineWidth: (d) => (d.properties['stroke-width'] ? d.properties['stroke-width'] : 3),
        pointType: 'circle',
        getFilterValue: (d) => d.properties.show,
        filterRange: [1, 1],
        extensions: [new DataFilterExtension({ filterSize: 1 }), new PathStyleExtension({ dash: true })],
        getDashArray: (d) => (d.properties.dottedLine ? d.properties.dottedLine : [3, 2]),
        dashJustified: true,
      },
    },
  })

  const getUserInfo = () => {
    setLoadingUserInfo(false)
    RpcApiClient.getUserInfo(authData.jwtToken).then((data) => {
      setUserInfo(data.data.data)
      data.data.data.user_company ? getCompanies(data.data.data.user_company) : setLoadingCompanies(true)
      setLoadingUserInfo(true)
    })
  }

  const getMaps = () => {
    setLoadingMaps(false)
    RpcApiClient.getUserMaps(authData.jwtToken).then((data) => {
      setMaps(data.data.data)
      setLoadingMaps(true)
    })
  }

  const getCompanies = (name) => {
    RpcApiClient.getCompanies().then((data) => {
      dispatch(setUserCompanyId(data.data.data.find((comp) => comp.name === name).company_id))
      dispatch(setUserCompanyName(data.data.data.find((comp) => comp.name === name).name))
      // console.log(data.data.data.find(comp => comp.name === name))
      setLoadingCompanies(true)
    })
  }

  useEffect(() => {
    getMaps()
    getUserInfo()
    // setTimeout(() => {
    //   console.log('INTERVALO ACTIVO')
    //   Auth.signOut().then(() => {
    //     dispatch(
    //       updateAuthData({
    //         authStatus: LOGED_OUT,
    //         jwtToken: '',
    //         email: '',
    //         emailVerified: false,
    //         groups: [],
    //       }),
    //     )
    //   })
    // }, 720 * 60 * 1000)
  }, [])

  useEffect(() => {
    var activeFiles = filesMenuInfo.data.filter((file) => file.s3 === true)
    if (seconds === 240 && activeFiles.length > 0) {
      // if (seconds === 60 && activeFiles.length > 0){
      // console.log('API_REQUEST',activeFiles)
      const body = {
        isBlocked: true,
        files: activeFiles,
      }
      RpcApiClient.lockFiles(authData.jwtToken, body)
    }
  }, [seconds])

  useEffect(() => {
    setInterval(() => {
      updateToken()
    }, 3600000)
  }, [])

  const updateToken = async () => {
    try {
      const data = await Auth.currentSession()
      dispatch(
        updateAuthData({
          groups: authData.groups,
          emailVerified: authData.emailVerified,
          email: authData.email,
          jwtToken: data.getAccessToken().getJwtToken(),
          authStatus: authData.authStatus,
        }),
      )
    } catch (err) {
      console.log(err)
    }
  }

  if (Object.keys(countrySelected || {}).length === 0) {
    if (maps.length > 0) {
      dispatch(setCountrySelected(maps[0]))
      dispatch(
        setViewStateStore({
          bearing: parseFloat(maps[0].map_location.bearing),
          latitude: parseFloat(maps[0].map_location.latitude),
          longitude: parseFloat(maps[0].map_location.longitude),
          pitch: parseFloat(maps[0].map_location.pitch),
          zoom: parseFloat(maps[0].map_location.zoom),
          country: parseFloat(maps[0].map_location.country),
        }),
      )
    }
  }

  if (loadingUserInfo && loadingMaps && loadingCompanies) {
    // if (loadingUserInfo && loadingMaps) {
    if (Object.keys(userInfo) === 0) {
      Auth.signOut().then(() => {
        dispatch(
          updateAuthData({
            authStatus: LOGED_OUT,
            jwtToken: '',
            email: '',
            emailVerified: false,
            groups: [],
          }),
        )
      })
      return <div></div>
    }

    const user_type = userInfo.user_type
    const user_name = userInfo.name
    const user_lastName = userInfo.last_name
    const user_tools = userInfo.user_tools

    const getMapLayers = (info) => {
      const state = mapLayersRef.current.getLayers()
      return state
    }

    return (
      <Router>
        <div style={{ height: '100%' }}>
          <Layout style={{ height: '100%' }}>
            <Layout.Header className="main-header">
              <div style={{ display: 'flex', height: '100%', width: '100%', position: 'relative' }}>
                <img alt="" src={tychoLogo} className="tycho-logo-header" />
                <div
                  style={{
                    height: '100%',
                    color: '#FFFFFF',
                    fontSize: '16px',
                    position: 'absolute',
                    right: '0px',
                    display: 'flex',
                  }}
                >
                  <label
                    style={{
                      color: '#FFFFFF',
                      fontSize: '16px',
                      alignSelf: 'center',
                    }}
                  >
                    {user_name} {user_lastName}
                  </label>
                  <UserOutlined
                    style={{
                      fontSize: '25px',
                      marginLeft: '30px',
                      alignSelf: 'center',
                    }}
                  />
                </div>
              </div>
            </Layout.Header>
            <Layout>
              <Sidebar
                selectedSection="TWITTER"
                user_type={user_type}
                user_tools={user_tools}
                setViewState={setViewState}
                getMapLayers={getMapLayers}
              />
              <Layout.Content style={{ overflow: 'hidden', height: '100%' }}>
                <Switch>
                  <Route exact path="/">
                    {/*<Map
                      ref={mapLayersRef}
                      countrySelected={countrySelected}
                      geoLayer={geoLayer}
                      viewState={viewState}
                      setViewState={setViewState}
                    />*/}
                    <GeoMap
                      countrySelected={countrySelected}
                      features={features}
                      setFeatures={setFeatures}
                      viewState={viewState}
                      setViewState={setViewState}
                    />
                  </Route>
                  <Route path="/map">
                    <Map
                      ref={mapLayersRef}
                      countrySelected={countrySelected}
                      user_tools={user_tools}
                      geoLayer={geoLayer}
                      viewState={viewState}
                      setViewState={setViewState}
                    />
                  </Route>
                  {user_tools ? (
                    user_tools.includes('geocreator') ? (
                      <Route path="/geocreator">
                        <GeoMap
                          countrySelected={countrySelected}
                          features={features}
                          setFeatures={setFeatures}
                          viewState={viewState}
                          setViewState={setViewState}
                        />
                      </Route>
                    ) : null
                  ) : null}
                  <Route path="/user-info">
                    <UserInfo />
                  </Route>
                  {user_type === 'admin' ? (
                    <Route path="/documents">
                      <Documents countrySelected={countrySelected} />
                    </Route>
                  ) : null}
                  {user_type === 'admin' ? (
                    <Route path="/users-manager">
                      <UsersManager />
                    </Route>
                  ) : null}
                  {user_type === 'admin' ? (
                    <Route path="/unifilar-editor">
                      <UnifilarEditor />
                    </Route>
                  ) : null}
                </Switch>
              </Layout.Content>
            </Layout>
          </Layout>
        </div>
      </Router>
    )
  } else {
    return (
      <div style={{ height: '100%', width: '100%' }}>
        <Spin style={{ marginTop: '25%' }} tip="Loading..." size="large" indicator={<LoadingOutlined />}>
          <div style={{ height: '100%', width: '100%' }}></div>
        </Spin>
      </div>
    )
  }
}

export default App
